const expandButton = document.getElementById("lux-checkout-preview-expand");

if (expandButton) {
    const luxCheckoutStickyWrapper = /** @type {HTMLElement} */ (
        document.querySelector(".lux-checkout-sticky-wrapper")
    );
    const luxCheckoutExtra = document.getElementById(
        "lux-checkout-preview-extra",
    );
    const luxCheckoutPreviewFullHeight = luxCheckoutStickyWrapper.offsetHeight;

    const reorderUpdateProducts = document.querySelectorAll(
        ".lux-cart-product .reorder-update-products",
    );

    const reorderChooseDelivery = document.getElementById(
        "reorder-choose-delivery",
    );

    const reorderDeliveryReminder = document.getElementById(
        "lux-cart-preview-reorder-reminder",
    );

    luxCheckoutStickyWrapper.classList.remove("expand", "expand-temp");

    const luxCheckoutExtraMargin = () => {
        if (luxCheckoutExtra) {
            /** @type {HTMLElement} */ (
                luxCheckoutStickyWrapper
            ).style.marginBottom = `${luxCheckoutExtra.offsetHeight}px`;
        }
    };

    const checkStickyState = () => {
        const rect = luxCheckoutStickyWrapper.getBoundingClientRect();
        const fullBottom = rect.top + luxCheckoutPreviewFullHeight;

        const isSticky = Math.round(fullBottom) >= window.innerHeight;
        const isStickyBottom = Math.round(rect.bottom) === window.innerHeight;

        if (!isSticky) {
            luxCheckoutStickyWrapper.classList.add("initial-position");
        }

        if (isStickyBottom) {
            luxCheckoutStickyWrapper.classList.remove("initial-position");
        }
    };

    /** @type {number | null} */
    let stickyStateFrame = null;

    /**
     * Coalesce a burst of scroll events into at most one check per frame.
     *
     * @returns {void}
     */
    const scheduleCheckStickyState = () => {
        if (stickyStateFrame !== null) {
            return;
        }

        stickyStateFrame = window.requestAnimationFrame(() => {
            stickyStateFrame = null;
            checkStickyState();
        });
    };

    const checkReorderDelivery = () => {
        if (reorderChooseDelivery && reorderDeliveryReminder) {
            reorderDeliveryReminder.classList.toggle(
                "show",
                !reorderChooseDelivery.classList.contains("hide"),
            );
        }
    };

    const handleReorderUpdateClick = () => {
        setTimeout(() => {
            luxCheckoutExtraMargin();
            checkReorderDelivery();
        }, 200);
    };

    reorderUpdateProducts.forEach((button) =>
        button.addEventListener("click", handleReorderUpdateClick),
    );

    expandButton.addEventListener("click", () => {
        luxCheckoutStickyWrapper.classList.toggle("expand");
        luxCheckoutExtraMargin();
    });

    window.addEventListener("scroll", scheduleCheckStickyState, {
        passive: true,
    });
    window.addEventListener("resize", scheduleCheckStickyState);

    luxCheckoutExtraMargin();
    checkReorderDelivery();
    checkStickyState();
}
